export default {
  title: 'Custom checkout message',
  description:
    'Set a custom message to display on the checkout page for your customers.',
  add_description:
    'Add a custom message to your checkout page to communicate compliance notices, policy disclaimers, or operational instructions.',
  image_alt: 'Preview of custom message on the checkout screen',
  empty_state: "You haven't added a custom message",
  add_button: 'Add a custom message',
  message_heading: 'Message',
  message_label: 'What your customers see during checkout',
  message_placeholder: 'Enter a message to display at checkout...',
  recommended:
    'Maximum %{max} characters - recommend less than %{recommend} characters',
  hyperlink_tip:
    "You can turn any part of your message into a hyperlink. Simply select the text you'd like to add or edit a link for.",
  edit: 'Edit',
  remove: 'Remove custom message',
  exit_without_saving: 'Exit without saving',
  save_and_publish: 'Save and publish',
  remove_modal: {
    title: 'Remove custom message',
    description:
      'Are you sure you want to remove your custom checkout message? This action cannot be undone.',
    confirm: 'Remove',
  },
  alerts: {
    save_success: 'Your checkout message has been saved.',
    save_error: 'Something went wrong. Please try again.',
    remove_success: 'Your checkout message has been removed.',
    remove_error: 'Something went wrong. Please try again.',
    fetch_error: 'Failed to load checkout settings. Please try refreshing.',
  },
}
